import * as $ from "jquery";
import '/modules/extended_report/css/timeseries/NavigableIndicatorChart.css';
import '/modules/extended_report/css/timeseries/NavigableIndicatorChart.responsive.css';
import {IndicatorChart} from "../../common/timeseries/IndicatorChart";
import {SimplifiedFixedInnerDatePicker} from "./SimplifiedFixedInnerDatePicker";
import {dateFromStr} from "../../common/time/TimeCalculator";
import {ToolConfig} from "../../map/config/MapConfig";

/**
 * An indicator chart that is navigable in time (until date is fixed)
 * @abstract
 * @extends IndicatorChart
 */
export class NavigableIndicatorChart extends IndicatorChart {

    /**
     *
     * @param id {string} An HTML id for this indicator chart
     * @param translator {Translator} A translator
     * @param indicator {Indicator} The indicator of this chart
     * @param until {Date} The end date for the chart is fixed
     * @param infoModal {Modal} A modal window to show indicator metadata in
     * @param runtimeConfig {RuntimeConfig} The map runtime config
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     */
    constructor(id, translator, indicator, until, infoModal, runtimeConfig, isMobileDevice) {
        super(id, translator, undefined, indicator, infoModal, runtimeConfig, isMobileDevice);
        this.until = until;
        this._calculateDates();
    }

    getClassName() {
        return "NavigableIndicatorChart";
    }

    _calculateDates() {
        this.originalUntil = this.until;
        const timeCalculator = this.layer.getTimeCalculator();
        const max = timeCalculator.min(this.layer.getDataUntil(), timeCalculator.fixDateUntil(timeCalculator.addDays(this.until, 30)));
        while (this.until <= max) {
            this.until = timeCalculator.getNextDate(this.until);
        }
        this.from = timeCalculator.fixDate(timeCalculator.addDays(this.originalUntil, -365 * 2));
    }

    getContainerElement() {
        const containerElement = super.getContainerElement();
        this.loader.show();
        containerElement.addClass('navigable');

        const chartContainerElement = $('.body .chart-container', containerElement);
        $('.body', containerElement)
            .remove(chartContainerElement)
            .prepend('<div class="no-data">'+this.translator.translate('tool.charts.noData')+'</div>')
            .prepend(
                $('<div class="date-picker-chart-container"></div>').append(chartContainerElement)
            );
        return containerElement;
    }

    _initDatePicker() {
        this.simplifiedDatePicker = new SimplifiedFixedInnerDatePicker(this.id + '_simplified_date_picker', this.translator, this.layer, this.layer.getTimeCalculator().fixDate(this.until), this.layer.getTimeCalculator().fixDate(this.from), this.isMobileDevice);
        const onchangeDatePicker = (picker) => this.setFrom(picker.getFrom());
        this.simplifiedDatePicker.onChange(onchangeDatePicker);
        onchangeDatePicker(this.simplifiedDatePicker);
    }

    _updateChart() {
        if (this.from && this.until && this.wgs84Coords) {
            super._updateChart();
            $('.date-picker-chart-container .simplified-date-picker', this.getUIElement()).remove();
            this._initDatePicker();
            if (this.simplifiedDatePicker) {
                $('.chart',this.getUIElement()).removeClass('no-data-chart');
                $('.no-data', this.getUIElement()).hide();
                $('.date-picker-chart-container', this.getUIElement()).prepend(this.simplifiedDatePicker.getUIElement());
            }else{
                $('.chart',this.getUIElement()).addClass('no-data-chart');
                $('.no-data', this.getUIElement()).show();
            }
            this.loader.hide();
        }
    }

    /**
     * Given a data object form the service, extract data for this indicator
     * To be overridden by specialized charts
     * @param dataFromService {Object}
     * @protected
     */
    _extractChartData(dataFromService) {
    }

    /**
     * Set the from date
     * @param from {Date}
     * @param update {boolean} Should the chart be updated
     */
    setFrom(from, update = true) {
        if (from) {
            this.from = dateFromStr(from);
            this.unboundedFrom = dateFromStr(from);
            this._updateFigCaptionContent();
            if (update) {
                this._generateChartElements();
            }
        }
    }

    /**
     *
     * @param until {Date}
     * @param wgs84Coords {Array<number>} 2 elements array with lon lat wgs84
     * @param update {boolean} Should the chart be updated?
     */
    setUntilAndCoords(until, wgs84Coords, update = true) {
        if (until) {
            this.until = until;
            this._calculateDates();
        }
        if (wgs84Coords && (!this.wgs84Coords || this.wgs84Coords[0] !== wgs84Coords[0] || this.wgs84Coords[1] !== wgs84Coords[1]))
            this.timeseriesFetcher = this.layer.getTimeseriesFetcher(wgs84Coords);
        this.wgs84Coords = wgs84Coords;
        if (update)
            this._updateChart();
    }

    _generateChartElements() {
        const timeseriesProcessor = this.layer.getTimeseriesProcessor(this.chartData);
        const data = timeseriesProcessor.getData(this.from, this.until);
        if (data) {
            const prodCode = this.layer.getProductConfig().getCode();
            this._renderChart(data, false, this.originalUntil);
            const downloadButton = $('<button class="download-data-button transparent" title="' + this.translator.translate('tool.charts.download.csv') + '"></button>');
            downloadButton.click(() => this._downloadData(prodCode));
            $('.body .indicator-buttons-container', this.uiElement).empty().append(downloadButton);
        } else {
            $('.body .indicator-buttons-container', this.uiElement).empty();
            $('.container .body .chart-container', this.uiElement).append($(
                '<div class="no-layers">Error loading data</div>'
            ));
        }
        this.loader.hide();
    }
}